import { config } from "@/puck/config";
import { Render } from "@measured/puck";
import { useParams } from "react-router-dom";
import "@measured/puck/puck.css";
import { useContext, useEffect, useState } from "react";
import { Page } from "@/type/common";
import AuthContext from "@/store/contexts/AuthContext";
import EmptyPage from "@/components/pages/home/EmptyPage";
import NavigatePage from "@/components/common/NavigatePage";

const PublicHome = () => {
  const { page_id } = useParams<{ page_id: string }>();
  const { pages, isEditor, isPdf, user } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState<Page | undefined | null>(
    undefined
  );

  useEffect(() => {
    if (pages.length === 1) {
      setCurrentPage(pages[0]);
      return;
    }

    setCurrentPage(pages.find((page) => page.id === page_id) || null);
  }, [page_id, pages, isPdf]);

  if (currentPage === undefined || currentPage === null) return null;

  return (
    <div className="flex h-screen w-full">
      <span className="loaded" />
      <NavigatePage />
      {!currentPage === null && (
        <EmptyPage isEditor={isEditor} noPages={pages.length === 0} />
      )}
      {currentPage && (
        <div className="flex-1">
          {!isPdf && <div className="h-4"></div>}
          {currentPage.content === null || currentPage.content.length === 0 ? (
            <EmptyPage isEditor={isEditor} />
          ) : (
            <Render config={config} data={currentPage} />
          )}
          {!isPdf && <div className="h-4"></div>}
        </div>
      )}
    </div>
  );
};

export default PublicHome;
